const hostName = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_HOST_PROD:process.env.REACT_APP_HOST_TEST;

export default {

	hostName: hostName,
    searchFailedPayments: hostName + "/dof-api/admin/payments/failed/search",
    createReceiptForFailedPayment: hostName + "/dof-api/admin/receipts/create/failed/payment",
    receiptTracking: hostName + "/dof-api/admin/receipts/tracking",
    receiptMaster: hostName + "/dof-api/admin/receipts/master",
    userLogin: hostName + "/dof-api/guest/admin/users",
    users: hostName + "/dof-api/admin/users",
    dashboard: hostName + "/dof-api/admin/dashboards",
    agency: hostName + "/dof-api/admin/departments",
    services: hostName + "/dof-api/admin/services",
    serviceItems: hostName + "/dof-api/admin/service-items",
    references: hostName + "/dof-api/admin/references",
    kinds: hostName + "/dof-api/admin/ref/kinds",
    reports: hostName + "/dof-api/admin/reports",
    province: hostName + "/dof-api/admin/provinces"
    
};